// extracted by mini-css-extract-plugin
export default {"container":"z1eno","value":"wUtYV"};